// extracted by extract-css-chunks-webpack-plugin
module.exports = {"transaction-id":"payment-comp__transaction-id--3frOm","transactionId":"payment-comp__transaction-id--3frOm"};